// extracted by mini-css-extract-plugin
export default {"wrapper":"HW12_wrapper__3ywwH","select":"HW12_select__VhX2J"};